export const companyLogo =
  "https://support305.com/wp-content/uploads/2022/05/Support305_HomePage_v2_03.png";


